import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import BottomNav from "../components/BottomNav";
import AddressSheet from "../components/AddressSheet";
import InternalHeader from "../components/InternalHeader";
import { useAppState } from "../context/AppState";
import { authenticatedApi } from "../lib/api";

export default function AddressesPage() {
  const { address, openAddress, saveUser, selectAddress, user } = useAppState();
  const [addresses, setAddresses] = useState([]);
  const [house, setHouse] = useState("");
  const [tag, setTag] = useState("Casa");
  const [loading, setLoading] = useState(Boolean(user));
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [adding, setAdding] = useState(false);

  useEffect(() => {
    if (!user?.auth_token) return;
    authenticatedApi("/get-addresses", user.auth_token, {
      method: "POST",
      body: "{}",
    })
      .then((rows) => setAddresses(Array.isArray(rows) ? rows : []))
      .catch((requestError) => setError(requestError.message))
      .finally(() => setLoading(false));
  }, [user]);

  async function saveCurrentAddress(event) {
    event.preventDefault();
    if (!address) {
      openAddress();
      return;
    }
    setSaving(true);
    setError("");
    try {
      const rows = await authenticatedApi("/save-address", user.auth_token, {
        method: "POST",
        body: JSON.stringify({
          latitude: address.lat,
          longitude: address.lng,
          address: address.address,
          house: house.trim(),
          tag: tag.trim() || "Casa",
        }),
      });
      setAddresses(Array.isArray(rows) ? rows : []);
      const saved = Array.isArray(rows) ? rows[0] : null;
      if (saved) {
        saveUser({
          ...user,
          default_address_id: saved.id,
          default_address: saved,
        });
      }
      setHouse("");
      setAdding(false);
    } catch (requestError) {
      setError(requestError.message);
    } finally {
      setSaving(false);
    }
  }

  async function makeDefault(saved) {
    setError("");
    try {
      const rows = await authenticatedApi("/set-default-address", user.auth_token, {
        method: "POST",
        body: JSON.stringify({ address_id: saved.id }),
      });
      setAddresses(Array.isArray(rows) ? rows : addresses);
      saveUser({
        ...user,
        default_address_id: saved.id,
        default_address: saved,
      });
      selectAddress({
        lat: Number(saved.latitude),
        lng: Number(saved.longitude),
        address: saved.address,
      });
    } catch (requestError) {
      setError(requestError.message);
    }
  }

  async function removeAddress(saved) {
    setError("");
    try {
      const rows = await authenticatedApi("/delete-address", user.auth_token, {
        method: "POST",
        body: JSON.stringify({ address_id: saved.id }),
      });
      setAddresses(Array.isArray(rows) ? rows : []);
    } catch (requestError) {
      setError(requestError.message);
    }
  }

  return (
    <main className="food-app">
      <InternalHeader title="Mis direcciones" backTo="/account" />
      <div className="addresses-page">
        {!user ? (
          <section className="empty-cart">
            <span>🔐</span>
            <h2>Inicia sesión para guardar direcciones</h2>
            <Link to="/account?next=/addresses">Iniciar sesión</Link>
          </section>
        ) : (
          <>
            <button className="new-address-button" type="button" onClick={() => setAdding((value) => !value)}>
              {adding ? "Cerrar" : "+ Nueva dirección"}
            </button>
            {adding && <form className="address-create" onSubmit={saveCurrentAddress}>
              <div className="address-create__selected">
                <span>⌖</span>
                <div>
                  <small>UBICACIÓN SELECCIONADA</small>
                  <b>{address?.address || "Aún no seleccionaste una ubicación"}</b>
                </div>
                <button type="button" onClick={openAddress}>Cambiar</button>
              </div>
              <div className="address-create__fields">
                <label>
                  Número, piso o referencia
                  <input value={house} onChange={(event) => setHouse(event.target.value)} />
                </label>
                <label>
                  Etiqueta
                  <select value={tag} onChange={(event) => setTag(event.target.value)}>
                    <option>Casa</option>
                    <option>Trabajo</option>
                    <option>Hotel</option>
                    <option>Otro</option>
                  </select>
                </label>
              </div>
              <button className="auth-submit" type="submit" disabled={saving}>
                {saving ? "Guardando…" : "Guardar esta dirección"}
              </button>
            </form>}

            {error && <div className="checkout-error">{error}</div>}
            {loading && <div className="food-message"><b>Cargando direcciones…</b></div>}
            <section className="saved-addresses">
              {addresses.map((saved) => {
                const isDefault = Number(user.default_address_id) === Number(saved.id);
                return (
                  <article className={isDefault ? "is-default" : ""} key={saved.id}>
                    <span>{saved.tag === "Trabajo" ? "🏢" : saved.tag === "Hotel" ? "🏨" : "🏠"}</span>
                    <div>
                      <h2>{saved.tag || "Dirección"}</h2>
                      <p>{saved.house ? `${saved.house}, ` : ""}{saved.address}</p>
                      {isDefault && <small>Dirección predeterminada</small>}
                    </div>
                    <div className="saved-addresses__actions">
                      {!isDefault && <button type="button" onClick={() => makeDefault(saved)}>Usar</button>}
                      <button className="is-delete" type="button" onClick={() => removeAddress(saved)}>Eliminar</button>
                    </div>
                  </article>
                );
              })}
            </section>
          </>
        )}
      </div>
      <BottomNav />
      <AddressSheet />
    </main>
  );
}
